import {Action, action} from 'easy-peasy';
import {Story, StoryAccess} from 'entities/story';
import {simpleCrudStoreFactory} from '@/utils/storeFactories';

export interface StoriesStoreModel {
    items: Story[];
    loadStories: Action<StoriesStoreModel, Story[]>;
    addOrEditStory: Action<StoriesStoreModel, Story>;
    editStoryAccess: Action<StoriesStoreModel, [storyId: number, storyAccesses: StoryAccess[]]>;
    deleteStory: Action<StoriesStoreModel, number>;
    deleteStoryAccess: Action<StoriesStoreModel, [storyId: number, userId: number]>;
}

export default <StoriesStoreModel>{
    // @ts-ignore
    ...(simpleCrudStoreFactory() as StoriesStoreModel),
    loadStories: action((state, storiesList) => {
        state.items = storiesList;
    }),
    addOrEditStory: action((state, story) => {
        const existingIndex = state.items.findIndex((s) => s.id === story.id);

        if (existingIndex !== -1) {
            state.items.splice(existingIndex, 1);
        }

        state.items.unshift(story);
    }),
    editStoryAccess: action((state, [storyId, storyAccesses]) => {
        const existingIndex = state.items.findIndex((s) => s.id === storyId);

        state.items[existingIndex].visibleTo = storyAccesses;
    }),
    deleteStory: action((state, storyId) => {
        const index = state.items.findIndex((s) => s.id === storyId);

        state.items.splice(index, 1);
    }),
    deleteStoryAccess: action((state, [storyId, userId]) => {
        const index = state.items.findIndex((s) => s.id === storyId);

        const existingIndex = state.items[index].visibleTo.findIndex((s) => s.id === userId);

        state.items[index].visibleTo.splice(existingIndex, 1);
    }),
};
